import { render, staticRenderFns } from "./AtendiendoView.vue?vue&type=template&id=34ed2a10"
import script from "./AtendiendoView.vue?vue&type=script&lang=js"
export * from "./AtendiendoView.vue?vue&type=script&lang=js"
import style0 from "./AtendiendoView.vue?vue&type=style&index=0&id=34ed2a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports